export default {
  'pages.propertyOverview.title': '物业总览',
  'pages.propertyOverview.subTitle':
    '用于集中展示物业的整体运营情况，汇总基础信息。',
  'pages.propertyOverview.monthlyStats.title': '本月收费统计',
  'pages.propertyOverview.monthlyStats.paidAmount': '本月累计已收',
  'pages.propertyOverview.monthlyStats.unpaidAmount': '待缴费总额',
  'pages.propertyOverview.monthlyStats.unpaidCount': '待缴费数量',
  'pages.propertyOverview.quickFunction.title': '快捷功能',
  'pages.propertyOverview.feeCenter.title': '收费中心',
  'pages.propertyOverview.commonFunction.title': '常用功能',
  'pages.propertyOverview.fee.property': '物业费',
  'pages.propertyOverview.fee.electric': '电费',
  'pages.propertyOverview.fee.water': '水费',
  'pages.propertyOverview.fee.network': '网费/宽带',
  'pages.propertyOverview.fee.parking': '停车费',
  'pages.propertyOverview.fee.parkingManagement': '车位管理费',
  'pages.propertyOverview.fee.other': '其它杂费',
  'pages.propertyOverview.fee.unit.pendingPayment': '笔待缴',
  'pages.propertyOverview.fee.unit.lowBalanceWarning': '低额预警',
  'pages.propertyOverview.fee.unit.abnormalFlow': '异常流量',
  'pages.propertyOverview.fee.unit.expiringSoon': '即将过期',
  'pages.propertyOverview.fee.unit.renewalPending': '待续费',
  'pages.propertyOverview.quickLink.importantNotice': '重要信息',
  'pages.propertyOverview.quickLink.paymentNotice': '缴费通知',
  'pages.propertyOverview.quickLink.utilityOpen': '水电网开通',
  'pages.propertyOverview.quickLink.venueBooking': '场地预约',
  'pages.propertyOverview.quickLink.vehicleBinding': '车辆绑定',
  'pages.propertyOverview.quickLink.dailyReport': '每日报表',
  'pages.propertyOverview.auditWorkbench.title': '待办审批工作台',
  'pages.propertyOverview.action.handle': '去处理',
  'pages.propertyOverview.audit.repair': '报修管理',
  'pages.propertyOverview.audit.complaint': '投诉管理',
  'pages.propertyOverview.audit.guest': '访客登记',
  'pages.propertyOverview.audit.decoration': '装修报备',
  'pages.propertyOverview.audit.moveout': '搬出登记',
  'pages.propertyOverview.audit.status.processing': '笔正在进行中',
  'pages.propertyOverview.audit.status.pending': '笔待处理记录',
};
